<template>
  <div class="container" id="aboutcontainer">
    <div class="row">
      <div class="col-md-6">
        <img src="../assets/Images/landingpic2.jpg" alt="" class="landingphoto">
      </div>
      <div class="col-md-6">        
        <h1>About Me</h1>
        <h5>I am an introspective and observant individual who is able to work to the best of my ability both in
        groups and alone. I don't usually feel comfortable being in large groups, but will warm up to those in
        the group given the opportunity to form relationships. Furthermore, I have been told that I have a
        friendly demeanour, despite outward appearances, and am always ready to make others smile. Something that I could stand to learn
        is to be more assertive and confident in myself and my ideas.
        </h5>
        <h5>My interest in coding comes from my hobbies. I am passionate about video games, having played for almost 14
        years, and have recently been swept up by researching different hardware options for my eventual PC
        upgrade. I want to grow my skillset to be a more appealing and well-rounded potential employee as well as cultivate skills that can help me be more
        connected and involved with the things that I enjoy.
        </h5>
      </div>
    </div>
  </div>
  
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h1>Soft Skills</h1>
        <div class="hardskills">
                    <h3 class="skilllist">Leadership Skills</h3>
                    <h3 class="skilllist">Time Management</h3>
                    <h3 class="skilllist">Problem Solving</h3>
                    <h3 class="skilllist">Data Analysis</h3>
                    <h3 class="skilllist"></h3>
                </div>
      </div>
      <div class="col-md-6"> 
        <img src="../assets/Images/landingphoto.jpg" alt="" class="landingphoto2">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style>
.landingphoto {
  width: 700px;
  height: 500px;
  margin-left: -50px;
  border-radius: 15%;
}

.landingphoto2 {
  width: 500px;
  height: 750px;
  border-radius: 15%;
}

#aboutcontainer {
  margin-top: 100px;
  margin-bottom: 100px;
}

</style>